import { apiClient } from './api';
import { PasswordlessAuthServiceBase, } from './passwordlessAuthServiceBase';
/**
 * Web implementation of passwordless authentication service.
 * Uses cookie-based authentication via apiClient.
 */
export class PasswordlessAuthService extends PasswordlessAuthServiceBase {
    /**
     * Request passwordless authentication.
     * Sends a magic link or OTP code to the user's email or phone.
     *
     * @param request - The passwordless auth request
     * @returns Promise with the response containing masked destination and expiry info
     */
    async requestAuth(request) {
        return await apiClient.post('/auth/passwordless/request', request);
    }
    /**
     * Verify a magic link token (web).
     * This endpoint sets an HTTP-only cookie for authentication.
     *
     * @param token - The magic link token from the URL
     * @returns Promise with the authenticated user and session info
     */
    async verifyMagicLink(token) {
        return await apiClient.get(`/auth/passwordless/verify?token=${encodeURIComponent(token)}`);
    }
    /**
     * Verify an OTP code (web).
     * This endpoint sets an HTTP-only cookie for authentication.
     *
     * @param request - The OTP verification request
     * @returns Promise with the authenticated user and session info
     */
    async verifyOTP(request) {
        return await apiClient.post('/auth/passwordless/verify-otp', request);
    }
    /**
     * Verify a magic link token (mobile).
     * Returns the JWT token in the response body for mobile storage.
     *
     * @param token - The magic link token from the URL
     * @returns Promise with the access token for mobile storage
     */
    async verifyMagicLinkMobile(token) {
        return await apiClient.get(`/auth/passwordless/verify/mobile?token=${encodeURIComponent(token)}`);
    }
    /**
     * Verify an OTP code (mobile).
     * Returns the JWT token in the response body for mobile storage.
     *
     * @param request - The OTP verification request
     * @returns Promise with the access token for mobile storage
     */
    async verifyOTPMobile(request) {
        return await apiClient.post('/auth/passwordless/verify-otp/mobile', request);
    }
    async requestPasswordReset(request) {
        return await apiClient.post('/auth/passwordless/request-reset', request);
    }
    async completePasswordReset(resetToken, newPassword) {
        return await apiClient.post('/auth/password/reset', { reset_token: resetToken, new_password: newPassword });
    }
}
export const passwordlessAuthService = new PasswordlessAuthService();
